<template>
  <div class="dcbj" v-if="kbxmlc">
    <div
      :class="[
        'box',
        isPublish != 1 || kbxmlc.zt == '2' || isPublish != 2 ? 'noBtn' : '',
      ]"
    >
      <!-- 主持人 -->
      <div class="clear">
        <p class="cont-title lf">多次报价</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchData"
            ></el-button>
          </el-input>
          <el-button
            type="primary"
            @click="kqbj"
            :class="[t ? 'djsBtn' : '']"
            :disabled="sfszqrsj"
            >{{ t ? t : "开启多次报价" }}</el-button
          >
        </div>
      </div>
      <el-table
        ref="table"
        border
        :data="tableData"
        style="width: 100%"
        max-height="570"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
          prop="qymc"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="180"
        ></el-table-column>
        <el-table-column width="140" show-overflow-tooltip :label="lastName">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.zt == 1">已确认</span>
            <span v-else style="color: #ec2b4f">未完成</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="clear">
        <span class="lf pageNum">共{{ total }}家。</span>
      </div>
    </div>
    <el-button
      type="primary lcNext"
      :disabled="waitLoading"
      @click="nextBtn"
      v-if="
        (isPublish == 1 && kbxmlc.zt != '2') ||
        (isPublish == 2 && kbxmlc.zt != '2')
      "
      >下一步</el-button
    >

    <!-- 发布报价弹窗 -->
    <!-- 设置时间 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <div>
          <span>设置开启报价结果确认时间</span>
          <el-input
            type="number"
            v-model.number="time"
            style="width: 120px"
          ></el-input>
          分钟
        </div>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waitLoading: false,
      dialogVisible: false,
      time: 5,
      tbdwmc: "",
      t: "",
      sfszqrsj: false,
      tableData: [],
      total: " ",
      size: null,
      isPublish: "", // 1 公开 0 未公开
      lastName: "",
      djlcId: "",
      kbxmlc: "",
      endCode: 0,
      num: 0,
      bdId: localStorage.getItem("bdId") ? localStorage.getItem("bdId") : "",
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
  methods: {
    async getData() {
      let para = {
        djlcId: this.djlcId,
        endCode: this.endCode,
        bjcs: this.size,
      };
      try {
        let res = await this.$api.dcbjquery(para);
        if (res.status == 200) {
          res.data.data.dcbj.forEach((ele) => {
            ele.zt = ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjzt;
            this.lastName =
              ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjcsmc;
            this.size = ele.size;
          });
          this.total = res.data.data.total;
          this.isPublish = res.data.data.isPublish;
          if (this.isPublish == 1 || this.isPublish == 2) {
            this.sfszqrsj = true;
          }
          this.tableData = res.data.data.dcbj;
          this.kbxmlc = res.data.data.kbxmlc;
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      } catch (err) {
        console.log("主持人", err);
      }
    },
    async searchData() {
      this.waitLoading = true;
      let para = {
        qymc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      try {
        let res = await this.$api.querylike(para);
        if (res.status == 200) {
          let a = res.data.data.dcbj;
          if (this.tbdwmc) {
            a.forEach((ele) => {
              ele.zt = ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjzt;
              this.lastName =
                ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjcsmc;
            });
            this.total = 1;
            this.tableData = [a[length - 1]];
          } else {
            res.data.data.dcbj.forEach((ele) => {
              ele.zt = ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjzt;
              this.lastName =
                ele.cgkbdcbjList[ele.cgkbdcbjList.length - 1].bjcsmc;
              this.size = ele.size;
            });
            this.total = res.data.data.total;
            this.tableData = res.data.data.dcbj;
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log("开启报价", err);
        this.waitLoading = false;
      }
    },
    // 开启报价
    kqbj() {
      this.dialogVisible = true;
      this.time = 5;
    },
    nextBtn() {
      this.waitLoading = true;
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.$emit("nextBtn", para);
      this.setKbbb();
    },
    async setKbbb() {
      try {
        let res = await this.$api.savetbdw();
        if (res.status == 200) {
          console.log("aaa", res);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      } catch (err) {
        console.log("下一步", err);
      }
    },
    //保存时间
    saveTime() {
      // let para = {
      //   qrsj: Number(this.time),
      // };
      // this.waitLoading = true;
      this.startBj();
      // this.$api
      //   .saveKqqrTime(para)
      //   .then((res) => {
      //     if (res.data.meta.success) {
      //       this.dialogVisible = false;
      //       this.$message({
      //         type: "success",
      //         message: "保存成功！",
      //       });
      this.sfszqrsj = true;
      this.kbbbshenyuFun(Number(this.time) * 60 * 1000);
      // this.getData();
      // let obj = {
      //   lx: "zb",
      //   data: {
      //     id: "",
      //   },
      // };
      // this.$emit("send", JSON.stringify(obj));
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: res.data.meta.message,
      //   });
      // }
      this.waitLoading = false;
      this.dialogVisible = false;
      // })
      // .catch(() => {});
    },
    //计算剩余时间倒计时
    kbbbshenyuFun(djs) {
      var _this = this;
      var time = Number(djs);
      var flag = false;
      _this.intervalKbbb = setInterval(function () {
        if (time < 1000) {
          clearInterval(_this.intervalKbbb);
          _this.intervalKbbb = null;
          _this.waitLoading = false;
          _this.sfszqrsj = false;
          _this.endCode = 1;
          if (!flag) {
            flag = true;
            _this.getData();
          }
          _this.t = "";
          return;
        }
        if (_this.num == 60) {
          _this.num = 0;
          _this.endCode = 0;
          _this.getData();
        }
        time = time - 1000;
        _this.num++;
        console.log(_this.num);
        var shengyuM = parseInt(time / (60 * 1000)); //毫秒数转换成分钟
        var M = time - shengyuM * 60 * 1000; //除去天、小时、分的毫秒数
        var S = parseInt(M / 1000); //除去天、小时、分的毫秒数转化为秒
        var ss = String(S);
        var mm = String(shengyuM);
        if (ss.length == 1) ss = "0" + ss;
        if (mm.length == 1) mm = "0" + mm;
        _this.t = mm + ":" + ss;
      }, 1000);
    },

    async startBj() {
      this.endCode = 0;
      let para = {};
      para.size = Number(this.size) + 1;
      try {
        let res = await this.$api.kqzcbj(para);
        if (res.status == 200) {
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      } catch (err) {
        console.log("开启报价", err);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalKbbb);
    this.intervalKbbb = null;
  },
};
</script>

<style lang='scss' scoped>
.dcbj {
  height: 100%;
}
</style>
